import { FC, useCallback, useState } from 'react';
import { Button, Form, FormItem, Header, Input, ScrollView } from '$uikit';
import { useDispatch } from 'react-redux';
import { Api } from '$api';
import { toastActions } from '$store/toast';
import { showModal } from '$navigation/helper';

export const NewApp: FC = () => {
  const dispatch = useDispatch();
  const [name, setName] = useState('');

  const handleCreate = useCallback(() => {
    dispatch(toastActions.setToastLoading());
    Api.post<any, { id: number }>('/app/create', {
      name: name.trim(),
    })
      .then((resp) => {
        dispatch(toastActions.hideToast());
        showModal(`editApp${resp.id}`, true);
      })
      .catch((err) => {
        dispatch(toastActions.setToastFail(err.message));
      });
  }, [name]);

  return (
    <>
      <Header showCloseButton>New App</Header>
      <ScrollView>
        <Form>
          <FormItem title="Name">
            <Input
              placeholder="Enter name..."
              value={name}
              onChange={({ target }) => setName(target.value)}
            />
          </FormItem>
          <FormItem>
            <Button onClick={handleCreate}>Create</Button>
          </FormItem>
        </Form>
      </ScrollView>
    </>
  );
};
